import {createAction} from '@reduxjs/toolkit'

/** 수신자 정보 자동입력 선택 */
export const transitionToAuto = createAction<boolean>('receiverInfo/transitionToAuto')

/** 수신자 정보 입력 */
export const changeReceiverName = createAction<string>('receiverInfo/changeReceiverName')

/** 수신자 정보 휴대폰 입력 */
export const changePhoneNumber = createAction<string>('receiverInfo/changePhoneNumber')
